var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73331 4.12051L2.65715 14.5457C2.17491 15.5078 2.86075 16.6667 3.92167 16.6667L16.074 16.6667C17.1349 16.6667 17.8315 15.5187 17.3385 14.5457L11.2623 4.12051C10.7372 3.07095 9.25841 3.07095 8.73331 4.12051Z",
    stroke: "#D0A074",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.26666V11.3167",
    stroke: "#D0A074",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2333C10.3452 14.2333 10.625 13.9535 10.625 13.6083C10.625 13.2632 10.3452 12.9833 10 12.9833C9.65482 12.9833 9.375 13.2632 9.375 13.6083C9.375 13.9535 9.65482 14.2333 10 14.2333Z",
    fill: "#C82A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningTriangle);
export default __webpack_public_path__ + "static/media/ic_warning_triangle.ae26dd12c2734100e6562a3c062a91a9.svg";
export { ForwardRef as ReactComponent };